'use strict'
angular.module('televisionServiceModule', [])
    .factory('televisionService', [function() {
        return {
        	getSearchType: function(){
        		return {
        			waitcompiled: 'tv.daibian',
        			pending: 'tv.daishen',
        			signed: 'tv.yiqianfa'
        		};
        	},
            getEditAndPreviewPath: function(){
                var path = {
                    edit: {
                        9: 'televisionmanuscript', //广电广电文稿
                        11: 'televisionplannedorder' //串联单
                    },
                    preview: {
                        9: 'televisionPreview',
                        11: 'seriesSheetPreview'
                    }
                };
                return path;
            }
        };
    }]);